import { ImageWrapper, IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Divider, IconButton, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { NCFGoal } from '@protos/analysis_management/analysis.teacher.apis_pb';
interface IProps {
  modalState: boolean;
  setModalState: (arg: boolean) => void;
  ncfMapping?: NCFGoal[];
}
const styles: IStyles = {
  modal: {
    boxSizing: 'border-box',
    display: { xs: 'flex' },
    alignItems: 'flex-end',
    top: { lg: '0' },
  },
  root: {
    backgroundColor: 'white',
    padding: { xs: pxToRem(15), md: pxTovW(23) },
    // backgroundColor: 'yellow',
    // overflow: 'hidden',
    overflowY: 'scroll',
    margin: 'auto',
    width: { xs: '90%', md: pxTovW(1000), lg: pxTovW(742) },
    height: { xs: 'max-content', md: 'max-content', lg: 'max-content' },
    maxHeight: { xs: pxToRem(400), md: pxTovW(758), lg: pxTovW(528) },
    borderRadius: { xs: pxToRem(10), md: pxToRem(15) },
    boxSizing: 'border-box',
    outline: 'none',
    boxShadow: `${pxTovW(0)} ${pxTovW(4)} ${pxTovW(18)} #3608918F ,${pxTovW(
      0
    )} ${pxTovW(-3)} ${pxTovW(10)}#292CE696 inset`,
    // mt: { md: '30vh' },

    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
};
export const NcfMappingPopup = (props: IProps) => {
  const { modalState, setModalState, ncfMapping } = props;

  return (
    <Modal
      open={modalState}
      onClose={() => {
        setModalState(false);
      }}
      sx={styles.modal}
    >
      <Box sx={{
        display: 'flex',
        justifyContent: { xs: 'center', md: 'start' },
        marginX: 'auto',
        flexDirection: { xs: 'column', md: 'row' },
        marginY: { xs: 'auto' },
      }}>
        <Box sx={styles.root}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              border: '1px solid #007CDC',
            }}
          >
            {ncfMapping?.map((elem, index) => {
              return (
                <Box
                  key={index}
                  sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#3F4D8F',
                      padding: pxTovW(23),
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        color: 'white',
                        fontWeight: 600,
                      }}
                    >
                      {elem.goalText}
                    </Typography>
                  </Box>
                  <Box>
                    {elem.competencies.map((e, i) => {
                      return (
                        <Box
                          key={i}
                          sx={{
                            boxSizing: 'border-box',
                            padding: pxTovW(23),
                            width: '100%',
                            borderBottom: i !== e.competencyText.length - 1 ? '1px solid #E0DFDE' : 'none',
                          }}
                        >
                          <Typography variant="h5" fontWeight={'regular'} >
                            {e.competencyText}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
        <IconButton
          color="inherit"
          onClick={() => setModalState(false)}
          sx={{
            marginX: 'auto',
            marginBottom: { md: 'auto' }
          }}
        >
          <ImageWrapper
            name="close-yellow"
            type="png"
            parentFolder="icons"
            styles={{
              top: '10%',
              width: '33px', // Small white "X"
              height: '33px',
            }}
          />
        </IconButton>
      </Box>
    </Modal >
  );
};
